module.exports = __webpack_public_path__ + "img/1.485d632a.png";